import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from '@/components/LandingPage'
import PrivacyPage from '@/components/PrivacyPage'
import TermsPage from '@/components/TermsPage'
import ContactPage from '@/components/ContactPage'
import ErrorPage from '@/components/general/ErrorPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/Privacy',
      name: 'PrivacyPage',
      component: PrivacyPage,
      meta: { bodyClass: 'has-navbar-fixed-top' }
    },
    {
      path: '/Terms',
      name: 'TermsPage',
      component: TermsPage,
      meta: { bodyClass: 'has-navbar-fixed-top' }
    },
    {
      path: '/Contact',
      name: 'ContactPage',
      component: ContactPage,
      meta: { bodyClass: 'has-navbar-fixed-top' }
    },
    {
      path: '*',
      name: 'ErrorPage',
      component: ErrorPage
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js